interface Props {
  // destination url to display
  destinationUrl: string;
}

const DisplayDestinationUrlComponent: React.FC<Props> = ({
  destinationUrl,
}) => {
  return (
    <p>
      Suppressed redirect to{' '}
      <a data-automation-id="suppressed-redirect-link" href={destinationUrl}>
        {destinationUrl}
      </a>
      <br />
    </p>
  );
};

export default DisplayDestinationUrlComponent;
